import { MouseEvent as ReactMouseEvent } from 'react'
import {
  hasTranslate3DSupport,
  make2dTransformValue,
  make3dTransformValue,
} from 'react-quick-pinch-zoom'
import { Point } from 'src/@interfaces'

export const MIN_ZOOM = 1
export const MAX_ZOOM = 2

export const MIN_ZOOM_TOLERANCE = MIN_ZOOM + 5 / 100

export const makeTransformValue = hasTranslate3DSupport()
  ? make3dTransformValue
  : make2dTransformValue

export const getZoomCoordinatesFromEvent = (
  ev: ReactMouseEvent<HTMLElement, MouseEvent>,
  innerEl: HTMLElement,
) => {
  const parentOffset = innerEl.offsetParent

  const parentClientRects = parentOffset?.getClientRects().item(0)

  return {
    x: ev.clientX - (parentClientRects?.left || 0),
    y: ev.clientY - (parentClientRects?.top || 0),
  }
}

export const getDistanceBetween = (from: Point, to: Point) => {
  const deltaX = to.x - from.x
  const deltaY = to.y - from.y

  return Math.sqrt(deltaX ** 2 + deltaY ** 2)
}

export const isMovementGreaterThanRatio = (from: Point, to: Point, ratio: number) =>
  getDistanceBetween(from, to) > ratio

export type OnZoomEventType = 'in' | 'out' | 'reset'

export const getZoomEventType = (scale: number, newScale: number): OnZoomEventType | null => {
  const isZoomingIn = newScale > scale
  const isZoomingOut = scale > newScale

  if (isZoomingIn) {
    return 'in'
  }
  if (isZoomingOut) {
    return 'out'
  }

  return null
}
